<form
  class="font-lato flex max-h-[calc(100vh-20px)] flex-col overflow-hidden text-black"
  [formGroup]="locationNameFormGroup"
  (ngSubmit)="saveLocationName()"
  novalidate
>
  <header
    class="border-gray-150 flex items-start justify-between gap-4 border-b px-6 pt-6 pb-4"
  >
    <div class="flex min-w-0 items-center gap-3">
      <span
        class="flex h-10 w-10 shrink-0 items-center justify-center"
        aria-hidden="true"
      >
        <mat-icon
          class="flex! h-5! w-5! items-center! justify-center! text-xl!"
        >
          {{ hasExistingLocationName ? 'edit' : 'add' }}
        </mat-icon>
      </span>
      <h1
        id="location-name-dialog-title"
        class="font-montserrat m-0 text-2xl leading-tight font-bold whitespace-normal"
      >
        {{ dialogTitle }}
      </h1>
    </div>

    <button
      type="button"
      class="text-brand-text/40 hover:text-brand-text/80 -mt-2 -mr-2 flex h-8 w-8 cursor-pointer items-center justify-center border-none bg-transparent transition-opacity focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-700 focus-visible:ring-offset-1"
      [mat-dialog-close]="false"
      aria-label="Close dialog"
    >
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </header>

  <section class="overflow-y-auto px-6 py-5 [-webkit-overflow-scrolling:touch]">
    <div class="border-gray-150 rounded-sm border bg-gray-50 p-4">
      <div class="flex items-start gap-3">
        <mat-icon
          fontSet="material-icons-outlined"
          class="mt-0.5 flex! shrink-0 items-center! justify-center! text-2xl!"
          aria-hidden="true"
          >place</mat-icon
        >
        <div class="min-w-0">
          <div
            class="text-brand-muted text-xs font-bold tracking-[1.5px] uppercase"
          >
            Service Address
          </div>
          <div class="mt-1 font-semibold wrap-break-word">
            {{ dialogData.locationAddress }}
          </div>
        </div>
      </div>
    </div>

    <div class="mt-5">
      <label class="comcast-input-label" for="location-name-alias">
        Location Name
        <span class="comcast-required-marker" aria-hidden="true">*</span>
      </label>
      <input
        id="location-name-alias"
        class="comcast-input"
        type="text"
        formControlName="locationNameAlias"
        placeholder="Headquarters"
        autocomplete="off"
        aria-required="true"
        aria-describedby="location-name-error location-name-save-error"
        [ngClass]="{
          'comcast-input-invalid': showLocationNameError,
        }"
        [attr.aria-invalid]="showLocationNameError"
      />

      <div id="location-name-error" class="min-h-7" aria-live="polite">
        @if (showLocationNameError) {
          <span class="comcast-validation-error">
            Location name is required
          </span>
        }
      </div>
    </div>

    @if (hasError()) {
      <div
        id="location-name-save-error"
        class="comcast-error-alert mt-3"
        role="alert"
      >
        <mat-icon class="comcast-error-alert-icon" aria-hidden="true">
          error
        </mat-icon>
        <p class="comcast-error-alert-text">
          <strong>Location name was not saved.</strong> Please try again.
        </p>
      </div>
    }
  </section>

  <footer
    class="border-gray-150 flex flex-col gap-3 border-t px-6 py-4 sm:flex-row sm:items-center sm:justify-between"
  >
    <div class="sm:min-w-36">
      @if (hasExistingLocationName) {
        <button
          type="button"
          class="btn-secondary w-full justify-center border-red-600! text-red-600! hover:bg-red-50! sm:w-auto"
          (click)="deleteLocationAlias()"
          [disabled]="isSaving()"
        >
          <mat-icon
            class="flex! h-5! w-5! items-center! justify-center! text-xl!"
            aria-hidden="true"
          >
            delete
          </mat-icon>
          Delete Name
        </button>
      }
    </div>

    <div class="flex flex-col-reverse gap-3 sm:flex-row">
      <button
        type="button"
        class="btn-secondary w-full justify-center sm:w-auto"
        [mat-dialog-close]="false"
        [disabled]="isSaving()"
      >
        Cancel
      </button>
      <button
        type="submit"
        class="btn-primary w-full justify-center sm:w-auto"
        [disabled]="isSaving() || locationNameFormGroup.invalid"
      >
        {{ isSaving() ? 'Saving' : saveButtonLabel }}
      </button>
    </div>
  </footer>
</form>
